<template>
  <b-col :md="colSize">
    <div class="form-row align-items-end">
      <div class="col-md col-md-6 input-group">
        <label class="form-label">{{ $t('Nome ou Login') }}</label>
        <b-input-group>
          <b-form-input :placeholder="$t('Nome ou Login')" v-model="nomeUsuario" :disabled="isDisabled" />
          <b-input-group-append>
            <b-button class="btn-sm-full" variant="primary" @click="getOptions()" :disabled="!nomeUsuario">
              <font-awesome-icon :icon="['fas', 'search']" size="1x"
            /></b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="col-md col-md-6">
        <label class="form-label">{{ $t('Usuário') }}</label>
        <multiselect
          v-model="selected"
          @input="onChange"
          :options="options"
          :custom-label="customLabel"
          :disabled="!nomeUsuario || isLoading"
          :allowEmpty="false"
          :preselectFirst="true"
          :loading="isLoading"
          selectLabel=""
          selectedLabel="«"
          deselectLabel=""
          label="label"
          track-by="id_usuario_sp"
          placeholder=""
        >
          <template slot="noResult" slot-scope="props">
            <span>{{ $t('Nenhum elemento encontrado') }}.</span>
          </template>
          <template slot="noOptions" slot-scope="props">
            <span>{{ $t('Nenhum dado foi retornado') }}.</span>
          </template>
          <template slot="placeholder" slot-scope="props">
            <span>{{ $t(emptyLabel) }}</span>
          </template>
        </multiselect>
      </div>
    </div>
  </b-col>
</template>
<script>
export default {
  props: {
    idUsuarioSelected: [String, Number],
    isRequired: Boolean,
    isDisabled: Boolean,
    includeAll: Boolean,
    emptyLabel: String,
    colSize: {
      default: 8
    },
    searchBy: {
      default: 'email_padrao'
    }
  },

  created() {
    if (this.idUsuarioSelected) this.getOptions(this.idUsuarioSelected);
  },

  data() {
    return {
      nomeUsuario: '',
      selected: '',
      options: [],
      isLoading: false
    };
  },

  watch: {
    idUsuarioSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getOptions(newVal);
        this.onChange();
      }
    },
    nomeUsuario(newValue) {
      if (!newValue && !this.idUsuarioSelected) {
        this.selected = '';
        this.onChange();
      }
    },
    options(newValue) {
      if (newValue && this.idUsuarioSelected) {
        this.selected =
          newValue.find((option) => String(option.id_usuario_sp) === String(this.idUsuarioSelected) || null) || '';
      }
    }
  },

  methods: {
    onChange(option) {
      this.$emit('input', option);
      this.$emit('selectChange', option ? option.id_usuario_sp : null);
    },
    getOptions(idUsuarioSelected) {
      let query = `business_logic.usuario.id_empresa_auth=${this.$store.state.user.info.id_empresa}
      AND business_logic.usuario.id_tipo_usuario = 3 AND business_logic.usuario.excluido=false`.trim();

      if (this.nomeUsuario) {
        query += ` AND ( business_logic.usuario.nome ILIKE '%${this.nomeUsuario}%' `;
        query += `OR business_logic.usuario.${this.searchBy} ILIKE '%${this.nomeUsuario}%')`;
      }

      if (idUsuarioSelected) {
        query += ` AND business_logic.usuario.id_usuario_sp=${idUsuarioSelected}`;
      }
      this.isLoading = true;
      this.$atenaList
        .getUsuariosSite({
          filter: query,
          order: 'nome'
        })
        .then((response) => {
          let options = [];
          if (this.includeAll) {
            options = [{ id_usuario_sp: '', nome: this.$i18n.t(this.emptyLabel) }];
          }
          options = options.concat(response.data);
          this.$set(this, 'options', options);
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.options = [];
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    customLabel({ nome, login }) {
      return nome && login ? `${nome} - ${login}` : nome;
    }
  }
};
</script>

<style lang="scss" scoped>
.input-group {
  display: flex;
}

.btn {
  height: fit-content;
}
</style>
